/*
 * flexGrowを0にすることでフッターを伸長させることなく最下部に配置できる。
 * @see https://mui.com/material-ui/react-drawer/#responsive-drawer
 */
import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const {index} = props;

  React.useEffect(() => {
    setValue(index);
  }, [index]);

  return (
    <footer>
    <Box>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        {/* <BottomNavigationAction 
            component={Link} 
            to="/" 
            label="TOP" 
            icon={<img alt="HOME" src="/assets/images/others/tab-home-active@3x.png"/>} 
        /> */}
        <BottomNavigationAction 
            component={Link} 
            to="/nature" 
            label={t("footer.menu_nature")}
            icon={<img alt="Nature" src="/assets/images/others/tab-nature-active@3x.png"/>} 
        />
        <BottomNavigationAction 
            component={Link} 
            to="/history" 
            label={t("footer.menu_history")}
            icon={<img alt="History" src="/assets/images/others/tab-history-active@3x.png"/>} 
        />
        <BottomNavigationAction 
            component={Link} 
            to="/facility" 
            label={t("footer.menu_facility")}
            icon={<img alt="Facility" src="/assets/images/others/menu_facility.svg"/>} 
        />
        <BottomNavigationAction 
            component={Link} 
            to="/station" 
            label={t("footer.menu_station")}
            icon={<img alt="Station" src="/assets/images/others/menu_station.svg?20250629"/>} 
        />
        <BottomNavigationAction 
            component={Link} 
            to="/barrier-free" 
            label={t("footer.menu_barrier")}
            icon={<img alt="Barrier Free" src="/assets/images/others/menu_barrier.svg"/>} 
        />
        {/* <BottomNavigationAction 
            component={Link} 
            to="/search" 
            label={t("footer.menu_search")}
            icon={<img alt="Search" src="/assets/images/others/tab-search-active@3x.png"/>} 
        /> */}
      </BottomNavigation>
    </Box>
    </footer>
  )
}
export default Footer